<template>
  <Page class="detailView">
    <div>
      <div class="pageContent-title">企业信息</div>
      <div class="mt-5">
        <a-form class="form" :form="form" :colon="false">
          <a-form-item label="所属企业">
            <a-input v-decorator="['companyName']" disabled></a-input>
          </a-form-item>
          <a-form-item label="企业类型">
            <a-select v-decorator="['companyType']" :options="typesMap.companyType" disabled></a-select>
          </a-form-item>
          <a-form-item label="登录手机号" required>
            <a-input
              v-decorator="[
                'phoneNumber',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入',
                    },
                  ],
                },
              ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="员工姓名" required>
            <a-input
              v-decorator="[
                'userName',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入',
                    },
                  ],
                },
              ]"
            ></a-input>
          </a-form-item>
          <a-form-item label="状态">
            <a-radio-group v-decorator="['isDisable', { initialValue: 0 }]">
              <a-radio v-for="item in typesMap.isDisable" :key="item.value" :value="item.value">
                {{ item.title }}
              </a-radio>
            </a-radio-group>
          </a-form-item>
        </a-form>
      </div>
    </div>
    <div class="detailView-actions">
      <a-button class="app-btn" type="default" @click="resetPassWord">重置密码</a-button>
      <a-button class="app-btn" type="default" @click="back">取消</a-button>
      <a-button class="app-btn" type="primary" @click="doSave">保存</a-button>
    </div>
  </Page>
</template>
<script>
import Page from '@/components/Page'
import { toolMixin, queryViewMixin } from '@/utils/mixin'
import { companyType } from '@/vars'
export default {
  components: {
    Page,
  },
  mixins: [toolMixin, queryViewMixin],
  data() {
    return {
      form: this.$form.createForm(this),
      detailData: null,
    }
  },
  computed: {
    typesMap() {
      return {
        isDisable: [
          {
            value: 1,
            title: '已禁用',
          },
          {
            value: 0,
            title: '已启用',
          },
        ],
        companyType,
      }
    },
  },
  methods: {
    doSave() {
      // /admin/companyUser/save
      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          const params = values
          try {
            await this.$axios.post('/company/admin/companyUser/save', {
              ...this.detailData,
              ...params,
            })
            this.$message.success('操作成功!')
            this.$router.go(-1)
          } catch (e) {
            console.error(e)
          }
        }
      })
    },
    back() {
      this.$router.go(-1)
    },
    async resetPassWord() {
      if (!this.detailData) {
        return
      }
      const { userName, userId, phoneNumber } = this.detailData
      const title = '确认重置账号？'
      const content = (
        <div class="pt-10 pb-10 text-center">
          确认要将【{userName}】的登录密码重置为
          <span class="text-red-500">123456</span>
          吗？
        </div>
      )
      await this.$modal({
        title,
        content,
      })
      await this.$axios.post('/user/admin/user/userResetPwd', {
        userId: userId,
        accountName: phoneNumber,
        password: '123456',
      })
      this.$message.success('操作成功')
      this.doQuery()
    },
    async loadById(id) {
      const res = await this.$axios.get('/company/admin/companyUser/queryByCompanyUserId', {
        params: {
          companyUserId: id,
        },
      })
      const detailData = res.data
      this.detailData = detailData
      this.safeSetFieldsValue$t(this.form, { ...detailData })
    },
  },
  mounted() {
    const id = this.$route.query.companyUserId
    if (id) {
      this.loadById(id)
    }
  },
}
</script>
<style lang="less" scoped></style>
